import { useQuery } from '@tanstack/react-query';
import { request } from 'javascripts/services/v3ApiClient';
import type {
  V3ApiSuccessfulResponse,
  V3ApiFailedResponse,
} from 'javascripts/services/v3ApiClient';
import { type GooglePlaceDetails } from 'data/v3/data-contracts';

type GooglePlacesResponse = V3ApiSuccessfulResponse<GooglePlaceDetails>;

export const useGetPlaceDetails = (placeId: string) => {
  return useQuery<GooglePlacesResponse, V3ApiFailedResponse>({
    queryFn: () => {
      return request({
        url: `/google_places/${placeId}`,
      });
    },
    queryKey: ['googlePlaceDetails', placeId],
    enabled: !!placeId,
  });
};
